import clsx from "clsx";
import { type PropsWithChildren, forwardRef } from "react";
import { Button as AriaButton } from "react-aria-components";

import { ArrowDropDownIcon } from "@/assets/icons/general/ArrowDropDown";
import { Typography } from "@/components/ui//text/Typography/Typography";
import { type TextInputVariantProps, textInput } from "@/components/ui/inputs/TextInput/TextInputWrapper";

export const DropdownButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<TextInputVariantProps & { className?: string; "data-testid"?: string }>
>(({ variant, children, className, "data-testid": dataTestId }, ref) => {
  return (
    <AriaButton
      ref={ref}
      className={textInput({
        variant,
        className: clsx("flex items-center justify-between gap-2", className),
      })}
      data-testid={dataTestId}
    >
      <Typography
        size="body-paragraph-xs"
        className="truncate text-white"
      >
        {children}
      </Typography>
      <ArrowDropDownIcon
        className="h-6 w-6 shrink-0 text-secondary-50 group-open:rotate-180"
        aria-hidden="true"
      />
    </AriaButton>
  );
});
